// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_firebase_compat_messaging_dist_esm_index_esm_js":"d07668d9bba04dc7","common":"bf556bc1a6b72aed","src_app_modules_customer-module_customer_module_ts":"af433b049f5a271e","src_app_modules_login-signup-module_login-signup_module_ts":"18a7e9faece10226"}[chunkId] + ".js";
};